import { useCallback } from "react";
import { useDispatch } from "react-redux";

export default function useCallbackWithAnalytics<
  T extends (...args: any) => any
>(callback: T, analyticsCallback: T) {
  const dispatch = useDispatch();

  return useCallback<T>(
    // @ts-ignore - not sure why my args aren't valid here
    (...args: any) => {
      dispatch(analyticsCallback(...args));
      callback(...args);
    },
    [dispatch, callback, analyticsCallback]
  );
}
